import React from 'react';
import 'react-lazy-load-image-component/src/effects/blur.css';
import './Contact.css';
import emailjs from 'emailjs-com';
import swal from 'sweetalert';
import useWindowPosition from '../hook/useWindowPosition';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faGithub, faLinkedinIn, faTwitter} from '@fortawesome/free-brands-svg-icons';

export default function Contact() {

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_uqciz3b', 'template_ll9u5t5', e.target, 
    'user_eUGxkP8KpDvEOQpcFseJW')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      swal("Good job!", "Your email has been sent", "success");
      e.target.reset();
}
  const animated = useWindowPosition('header', 0.6, 4);
  return (
    <div
      className=" min-h-screen  flex justify-center items-center  "
      id="contact"
    > 
      <div
        style={{
          minHeight: '70vh',
          background: '#091C29',
        }}
        className="w-full md:w-4/5 md:rounded-xl shadow-2xl flex  flex-col-reverse justify-around items-center">
            <div>
            <a href={`https://github.com/osmanfaaruk`}>
            <FontAwesomeIcon className="media-icon" icon={faGithub} />
            </a>
            <a href={`https://www.linkedin.com/in/osmanfaaruk/`}>
            <FontAwesomeIcon className="media-icon ms-3"  icon={faLinkedinIn} />
            </a>
            <a href={`https://twitter.com/osmanfaaruk`}>
            <FontAwesomeIcon className="media-icon ms-3"  icon={faTwitter} />
            </a>
            </div>
        <div className="font-dosis w-4/5 md:w-2/5 mt-5 transtion duration-2000">
          <form onSubmit={sendEmail} required>
                <div className="mx-auto">

                    <div className="form-group">
                        <input type="text" className="form-control form" placeholder="Name" name="name"required />
                        <span class="focus-border"></span>
                    </div>

                    <div className="form-group pt-2">
                        <input type="text" className="form-control form" placeholder="Email" name="email"required />
                        <span class="focus-border"></span>
                    </div>

                    <div className="form-group pt-2">
                        <input type="text" className="form-control form" placeholder="Subject" name="subject" required/>
                        <span class="focus-border"></span>
                    </div>

                    <div className="form-group pt-2 ">
                       <textarea className="form-control form" cols="30" rows="10" placeholder="Your message" 
                       name="message" required/>
                       <span class="focus-border"></span>
                    </div>

                    <div className="form-group  pt-2">
                        <button className="send-msg-btn">Send</button>
                    </div>
                </div>
            </form>
        </div>
      </div>
    </div>
  );
}
